import { toast } from 'sonner'

/** Accept legacy (enqueueSnackbar, message) or (message). */
function resolveMessage(a, b) {
  if (b !== undefined) return b
  return a
}

/**
 * Success toast — legacy enqueueSnackbar arg ignored.
 * Call: showSuccessSnackbar(message) or showSuccessSnackbar(_, message)
 */
export default function showSuccessSnackbar(a, b) {
  const message = resolveMessage(a, b)
  if (!message) return
  toast.success(String(message), { duration: 3500 })
}
